<template>
  <div class="space-y-4 text-center">
    <Icon name="mgd:midland" size="100" class="text-primary mx-auto" />
    <p class="text-danger text-center text-lg font-semibold">
      An unexpected error has occurred. If this problem persists then contact
      Midland support by phone at
      <a href="tel:18004374056">1-800-437-4056</a> or by email at
      <a href="mailto:info@midlandgaragedoor.com">info@midlandgaragedoor.com</a>
    </p>
    <NuxtLink to="/" as-child>
      <MgdButton size="sm">Home</MgdButton>
    </NuxtLink>
  </div>
  <ErrorStackTrace :error="error" />
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";
defineProps<{ error: NuxtError }>();
</script>
